import React from 'react'
import { Dialog } from 'components/Dialog'
import Logo from 'components/Logo'
import { Box } from 'components/Layout'
import { Text } from 'components/Typography'
import QRCode from 'qrcode.react'

interface AttendeeInfoProps {
  isOpen: boolean
  onDismiss: () => void
  title: string
  subTitle: string
  qrCodeValue: string
}

export const QRCodeModal: React.VFC<AttendeeInfoProps> = ({
  isOpen,
  onDismiss,
  title,
  subTitle,
  qrCodeValue,
}) => (
  <Dialog isOpen={isOpen} maxWidth="550px" onDismiss={onDismiss}>
    <Box
      textAlign="center"
      display="flex"
      p="1rem"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Logo />
      <Text fontWeight="bold" fontSize="2rem" my="1rem">
        {title}
      </Text>

      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Text mb="1rem">{subTitle}</Text>
        <QRCode value={qrCodeValue} level="H" size={250} />
      </Box>
      <Logo />
    </Box>
  </Dialog>
)
